"use client";

import { useEffect } from "react";
import { LAST_SEEN_CHANGELOG_VERSION_KEY } from "@/lib/update-notification-keys";

/**
 * Marks the current changelog as seen so the post-update "want to see what's new?"
 * prompt only appears when there's actually a new entry.
 * Mounted on `/changelog` with the server's latest version.
 */
export function ChangelogSeenMarker({ latestVersion }: { latestVersion: string }) {
  useEffect(() => {
    try {
      if (latestVersion) {
        localStorage.setItem(LAST_SEEN_CHANGELOG_VERSION_KEY, latestVersion);
      }
    } catch {
      // storage blocked — ignore
    }
  }, [latestVersion]);

  return null;
}
